// /**
//  * section-slideshow.js
//  *
//  * Fixes the "Adapt to first image" height bugs:
//  *  - Liquid can only guess the aspect ratio from image metadata, which is
//  *    sometimes missing and never accounts for the mobile image differing
//  *    from the desktop image. The CSS `aspect-ratio: var(--aspect-desktop)`
//  *    / `var(--aspect-mobile)` set inline from Liquid is the CLS-safe
//  *    first paint; this script *upgrades* that guess to the real,
//  *    measured image dimensions once each image is available, and keeps it
//  *    correct across the desktop/mobile breakpoint and window resizes.
//  *
//  * Does not touch fixed-height modes (450/550/650/750/full/full-header) —
//  * those never carry data-adapt-height="true" and this script no-ops for them.
//  */
// (function () {
//   'use strict';

//   var MOBILE_QUERY = '(max-width:749px)';
//   var measuredCache = new WeakMap(); // element -> {url: ratio}

//   function firstUrlFromBgset(bgset) {
//     if (!bgset) return null;
//     // bgset format: "url1 100w, url2 200w, ..." — take the first candidate.
//     var first = bgset.split(',')[0].trim().split(' ')[0];
//     return first || null;
//   }

//   function measureRatio(el) {
//     return new Promise(function (resolve) {
//       if (!el) return resolve(null);

//       // Background-image element populated by lazysizes bgset/currentSrc.
//       var url =
//         el.currentSrc ||
//         (el.style && el.style.backgroundImage
//           ? el.style.backgroundImage.replace(/^url\(["']?/, '').replace(/["']?\)$/, '')
//           : null) ||
//         firstUrlFromBgset(el.getAttribute('data-bgset'));

//       // <img> element fallback (non-adaptive-cover mobile mode).
//       if (!url && el.tagName === 'IMG') {
//         url = el.currentSrc || el.src || el.getAttribute('data-src');
//       }

//       if (!url) return resolve(null);

//       var cache = measuredCache.get(el) || {};
//       if (cache[url]) return resolve(cache[url]);

//       var img = new Image();
//       img.onload = function () {
//         if (img.naturalWidth && img.naturalHeight) {
//           var ratio = img.naturalWidth / img.naturalHeight;
//           cache[url] = ratio;
//           measuredCache.set(el, cache);
//           resolve(ratio);
//         } else {
//           resolve(null);
//         }
//       };
//       img.onerror = function () {
//         resolve(null);
//       };
//       img.src = url;
//     });
//   }

//   function firstSlide(wrapper) {
//     return wrapper.querySelector('.slideshow__slide, .slide');
//   }

//   function pickImageEl(slide, isMobile) {
//     if (!slide) return null;
//     if (isMobile) {
//       return (
//         slide.querySelector('.img_mobile.slideshow__image') ||
//         slide.querySelector('.img_mobile img') ||
//         slide.querySelector('.slideshow__image')
//       );
//     }
//     return slide.querySelector(
//       '.slideshow__image:not(.img_mobile):not(.d-none)'
//     ) || slide.querySelector('.slideshow__image');
//   }

//   function refresh(wrapper) {
//     var isMobile = window.matchMedia(MOBILE_QUERY).matches;
//     var slide = firstSlide(wrapper);
//     var el = pickImageEl(slide, isMobile);

//     measureRatio(el).then(function (ratio) {
//       if (!ratio) return; // keep the Liquid-computed fallback
//       var prop = isMobile ? '--aspect-mobile' : '--aspect-desktop';
//       var current = wrapper.style.getPropertyValue(prop);
//       var next = ratio.toFixed(4);
//       if (current !== next) {
//         wrapper.style.setProperty(prop, next);
//       }
//     });
//   }

//   function debounce(fn, wait) {
//     var t;
//     return function () {
//       clearTimeout(t);
//       var args = arguments;
//       var ctx = this;
//       t = setTimeout(function () {
//         fn.apply(ctx, args);
//       }, wait);
//     };
//   }

//   function init() {
//     var wrappers = document.querySelectorAll(
//       '.slideshow[data-adapt-height="true"]'
//     );
//     if (!wrappers.length) return;

//     wrappers.forEach(function (wrapper) {
//       refresh(wrapper);

//       // Lazysizes fires this once a bg image / img finishes loading.
//       wrapper.addEventListener('lazyloaded', function (e) {
//         if (firstSlide(wrapper).contains(e.target) || e.target === firstSlide(wrapper)) {
//           refresh(wrapper);
//         }
//       });

//       var onResize = debounce(function () {
//         refresh(wrapper);
//       }, 150);
//       window.addEventListener('resize', onResize);
//     });
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }
// })();



































/**
 * section-slideshow.js
 *
 * Fixes the "Adapt to first image" height bugs:
 *  - Liquid can only guess the aspect ratio from image metadata, which is
 *    sometimes missing and never accounts for the mobile image differing
 *    from the desktop image. The CSS `aspect-ratio: var(--aspect-desktop)`
 *    / `var(--aspect-mobile)` set inline from Liquid is the CLS-safe
 *    first paint; this script *upgrades* that guess to the real,
 *    measured image dimensions once each image is available, and keeps it
 *    correct across the desktop/mobile breakpoint and window resizes.
 *
 * Does not touch fixed-height modes (450/550/650/750/full/full-header) —
 * those never carry data-adapt-height="true" and this script no-ops for them.
 */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width:749px)';
  var measuredCache = new WeakMap(); // element -> {url: ratio}

  function firstUrlFromBgset(bgset) {
    if (!bgset) return null;
    // bgset format: "url1 100w, url2 200w, ..." — take the first candidate.
    var first = bgset.split(',')[0].trim().split(' ')[0];
    return first || null;
  }

  function measureRatio(el) {
    return new Promise(function (resolve) {
      if (!el) return resolve(null);

      // Background-image element populated by lazysizes bgset/currentSrc.
      var url =
        el.currentSrc ||
        (el.style && el.style.backgroundImage
          ? el.style.backgroundImage.replace(/^url\(["']?/, '').replace(/["']?\)$/, '')
          : null) ||
        firstUrlFromBgset(el.getAttribute('data-bgset'));

      // <img> element fallback (non-adaptive-cover mobile mode).
      if (!url && el.tagName === 'IMG') {
        url = el.currentSrc || el.src || el.getAttribute('data-src');
      }

      if (!url) return resolve(null);

      var cache = measuredCache.get(el) || {};
      if (cache[url]) return resolve(cache[url]);

      var img = new Image();
      img.onload = function () {
        if (img.naturalWidth && img.naturalHeight) {
          var ratio = img.naturalWidth / img.naturalHeight;
          cache[url] = ratio;
          measuredCache.set(el, cache);
          resolve(ratio);
        } else {
          resolve(null);
        }
      };
      img.onerror = function () {
        resolve(null);
      };
      img.src = url;
    });
  }

  function firstSlide(wrapper) {
    return wrapper.querySelector('.slideshow__slide, .slide');
  }

  function pickImageEl(slide, isMobile) {
    if (!slide) return null;
    if (isMobile) {
      return (
        slide.querySelector('.img_mobile.slideshow__image') ||
        slide.querySelector('.img_mobile img') ||
        slide.querySelector('.slideshow__image')
      );
    }
    return slide.querySelector(
      '.slideshow__image:not(.img_mobile):not(.d-none)'
    ) || slide.querySelector('.slideshow__image');
  }

  function refresh(wrapper) {
    var isMobile = window.matchMedia(MOBILE_QUERY).matches;
    var slide = firstSlide(wrapper);
    var el = pickImageEl(slide, isMobile);

    measureRatio(el).then(function (ratio) {
      if (!ratio) return; // keep the Liquid-computed fallback
      var prop = isMobile ? '--aspect-mobile' : '--aspect-desktop';
      var current = wrapper.style.getPropertyValue(prop);
      var next = ratio.toFixed(4);
      if (current !== next) {
        wrapper.style.setProperty(prop, next);
      }
    });
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments;
      var ctx = this;
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function ensureSlick(root) {
    if (typeof window.jQuery === 'undefined' || !window.jQuery.fn || typeof window.jQuery.fn.slick !== 'function') {
      return;
    }
    var $ = window.jQuery;
    var $scope = root ? $(root) : $(document);
    var $slideshows = $();
    if ($scope.is('.slideshow')) {
      $slideshows = $slideshows.add($scope);
    }
    $slideshows = $slideshows.add($scope.find('.slideshow')).add($scope.closest('.slideshow'));
    if (!$slideshows.length) {
      $slideshows = $('.slideshow');
    }
    $slideshows.each(function () {
      var $el = $(this);
      if ($el.hasClass('slick-initialized')) {
        var dotVal = $el.attr('data-dot');
        if (typeof dotVal === 'undefined') dotVal = $el.data('dot');
        var wantsDots = (dotVal === true || dotVal === 'true' || dotVal === 1 || dotVal === '1');
        var hasDots = $el.find('.slick-dots').length > 0;
        var slideCount = $el.find('.slideshow__slide:not(.slick-cloned)').length;

        if (wantsDots && slideCount > 1 && !hasDots) {
          try {
            $el.slick('unslick');
          } catch (e) {}
        } else {
          try {
            $el.slick('setPosition');
          } catch (e) {}
          return;
        }
      }
      var $sec = $el.closest('[data-section-id]');
      var sectionId = $sec.attr('data-section-id') || ($el.attr('id') || '').replace('Slideshow-', '');
      if (window.theme && typeof window.theme.Slideshow === 'function') {
        new window.theme.Slideshow($el, sectionId);
      }
    });
  }

  function refreshAll() {
    var wrappers = document.querySelectorAll(
      '.slideshow[data-adapt-height="true"]'
    );
    if (wrappers.length) {
      wrappers.forEach(function (wrapper) {
        refresh(wrapper);
      });
    }
    if (typeof window.jQuery !== 'undefined') {
      window.jQuery('.slideshow.slick-initialized').each(function () {
        try {
          window.jQuery(this).slick('setPosition');
        } catch (e) {}
      });
    }
  }

  var onGlobalResize = debounce(refreshAll, 100);
  window.addEventListener('resize', onGlobalResize);
  window.addEventListener('orientationchange', onGlobalResize);

  function init() {
    var wrappers = document.querySelectorAll(
      '.slideshow[data-adapt-height="true"]'
    );
    if (wrappers.length) {
      wrappers.forEach(function (wrapper) {
        refresh(wrapper);

        // Lazysizes fires this once a bg image / img finishes loading.
        wrapper.addEventListener('lazyloaded', function (e) {
          if (firstSlide(wrapper).contains(e.target) || e.target === firstSlide(wrapper)) {
            refresh(wrapper);
          }
        });
      });
    }

    ensureSlick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function () {
    ensureSlick();
  });

  // Shopify Theme Editor support: re-initialize when sections or blocks reload/select
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('.slideshow[data-adapt-height="true"]')) {
      init();
    }
    ensureSlick(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    ensureSlick(e.target);
  });
  document.addEventListener('shopify:section:reorder', function (e) {
    ensureSlick(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var wrapper = e.target ? e.target.closest('.slideshow[data-adapt-height="true"]') : null;
    if (wrapper) {
      refresh(wrapper);
    }
    ensureSlick(e.target);
  });

  if (window.Shopify && window.Shopify.designMode) {
    setInterval(function () {
      ensureSlick();
    }, 500);
  }
})();